import "./Avatar.css";
import { useState } from "react";

const SIZES = { sm: 24, md: 32, lg: 40 };

export function initialsFor(name) {
  return String(name || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

function atSize(url, pixels) {
  if (!url) return null;
  if (/^\/avatars\//.test(url)) return url;
  return url.replace(/=s\d+(-c)?$/, `=s${pixels}-c`);
}

export default function Avatar(props) {
  const [failed, setFailed] = useState(false);
  const size = SIZES[props.size || "sm"];
  const src = failed ? null : atSize(props.src, size * 2);

  if (!src) {
    return (
      <span
        className={`avatar avatar-${props.size || "sm"} avatar-fallback`}
        aria-hidden="true"
      >
        {initialsFor(props.name)}
      </span>
    );
  }

  return (
    <img
      className={`avatar avatar-${props.size || "sm"}`}
      src={src}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
    />
  );
}
